import { ReactNode } from 'react';
import { ReactComponent as LineageIcon } from '../../assets/lineage-nav-button-2.svg';
import useNavigateWithEnvParam from '../../hooks/useNavigateWithEnvParam';
import useSelectedTreeItem from '../../hooks/useSelectedTreeItem';
import Button from '../Button';
import WidgetButton from '../WidgetButton';
import { TREE_NODE, TESTS_FILTER } from '../../constants/urlParams';

type Props = {
  modelId?: string;
  testName?: string;
  columnName?: string;
  buttonStyle?: 'widget' | 'button';
  children?: ReactNode;
  disabled?: boolean;
};

const TestLineageNavButton = ({
  modelId,
  testName,
  columnName,
  buttonStyle = 'widget',
  children,
  disabled,
}: Props) => {
  const navigate = useNavigateWithEnvParam();
  const { formatUrlParam } = useSelectedTreeItem();

  const handleLineageNav = () => {
    const newParams = new URLSearchParams();

    if (modelId) {
      const urlParam = formatUrlParam(
        modelId,
        columnName
          ? `column.${modelId}.${columnName.toLowerCase()}`
          : undefined,
        columnName ? 'column' : undefined,
      );
      if (urlParam) {
        newParams.set(TREE_NODE, urlParam);
      }
    }

    if (testName && !columnName) {
      newParams.set(TESTS_FILTER, JSON.stringify([testName]));
    }

    navigate(`/report/lineage?${newParams.toString()}`);
  };

  return buttonStyle === 'widget' ? (
    <WidgetButton
      onClick={handleLineageNav}
      startIcon={<LineageIcon width={12} />}
    >
      Lineage
    </WidgetButton>
  ) : (
    <Button
      variant="outlined"
      onClick={handleLineageNav}
      startIcon={<LineageIcon width={12} />}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default TestLineageNavButton;
